import { render } from "./ColumnSort.vue?vue&type=template&id=27007106"
import script from "./ColumnSort.vue?vue&type=script&lang=js"
export * from "./ColumnSort.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp8\\htdocs\\edb_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__